import { GDT } from "@/types";
import { GeoJSON } from "geojson";
import { DatasetRecord } from "@/types/DatasetRecord";
import { AddressLocation } from "@/types/location/AddressLocation";
import { CoordinateLocation } from "@/types/location/CoordinateLocation";
import { DatasetLocation } from "@/types/location/DatasetLocation";
import { GeometryLocation } from "./GeometryLocation";
import { GammaAccuracy } from "@/types/location/location-accuracy";

export interface IAddress {
  addressProvider: "Native" | "Autoaddress" | "Precisely";
  country: string;
  address: string[];
  postcode?: string;
  precisionLevel?: number;
}

export interface IAutoaddressAddress extends IAddress {
  addressProvider: "Autoaddress";
  matchLevel: number;
  matchResult: number;
  ecadId?: number;
}

export interface IPreciselyAddress extends IAddress {
  addressProvider: "Precisely";
  precisionLevel: number;
  uprn: number;
}

export type AnyAddress = IPreciselyAddress | IAddress | IAutoaddressAddress;

export interface IDisplayItem {
  name?: string;
  value: any;
  type?: string;
  _column?: GDT.ColumnDefinition;
}

export interface IDisplaySection {
  isOpen?: boolean;
  name: string;
  items: IDisplayItem[];
  type: "Address" | "Table" | "Coordinate" | string;
}

export type locationType =
  | "Coordinate"
  | "Address"
  | "Policy"
  | "Claim"
  | "Record"
  | "Geometry";

export interface ILocation {
  record?: DatasetRecord;
  address?: any;
  type: locationType;
  title?: string;
  geometry?: GeoJSON.Geometry | string;
  query?: Record<string, any> | null;
  lcId?: string;
  precisionAccuracy?: GammaAccuracy;
}

export interface LatLng {
  lat: number | null;
  lng: number | null;
}

export type AnyLocation =
  | AddressLocation
  | CoordinateLocation
  | DatasetLocation
  | GeometryLocation;

export * from "./energy-rating";
